<template>
  <div>
    <form>
      <fieldset>
        <legend class="text-primary">
          {{ $t('dealerProfile.account') }}
        </legend>
        <div class="row">
          <div class="col-md-6">
            <label class="required">{{ $t('dealerProfile.userName') }}</label>
            <input v-model="model.user_name" type="text" class="form-control" />
            <div class="validate" v-if="errors.has('user_name')">
              {{ errors.first('user_name') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="required">{{ $t('dealerProfile.password') }}</label>
            <input
              v-model="model.password"
              type="password"
              class="form-control"
            />
            <div class="validate" v-if="errors.has('password')">
              {{ errors.first('password') }}
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'userLogin',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
